module.exports = __webpack_public_path__ + "static/vib_play1s-6440867dfe62a7250f917f82b231e17c.jpg";